const SLException = Mach.requireModule('SLException');

// 核心交易链路异常
export function reportFrontendCoreException(params: {
  message: string;
  extra?: any;
  biz?: string;
  level?: 'error' | 'warn' | 'info' | 'debug';
}) {
  SLException?.reportFrontendCoreException(params);
}

// 页面模块渲染失败
export function reportFrontendModuleException(params: {
  message: string;
  extra?: any;
  biz?: string;
  level?: 'error' | 'warn' | 'info' | 'debug';
}) {
  SLException?.reportFrontendModuleException(params);
}

// code != 0，API路径
export function reportBackendException(params: {
  code: any;
  path: string;
  message?: string;
  extra?: any;
  biz?: string;
  level?: 'error' | 'warn' | 'info' | 'debug';
}) {
  SLException?.reportBackendException(params);
}

// 图片加载失败
export function reportImageException(params: {
  message: string;
  path: string;
  extra?: any;
  biz?: string;
  level?: 'error' | 'warn' | 'info' | 'debug';
}) {
  SLException?.reportImageException(params);
}

// 视频加载失败
export function reportVideoException(params: {
  message: string;
  path: string;
  extra?: any;
  biz?: string;
  level?: 'error' | 'warn' | 'info' | 'debug';
}) {
  SLException?.reportVideoException(params);
}

// try Exception
export function reportCodeTryException(params: {
  message: string;
  extra: any;
  biz?: string;
  level?: 'error' | 'warn' | 'info' | 'debug';
}) {
  SLException?.reportCodeTryException(params);
}

// try Exception
export function reportJsonParseException(extra: any) {
  reportCodeTryException({
    message: 'jsonParse',
    extra
  });
}

// Assert
export function reportAssertException(params: {
  message: string;
  extra?: any;
  biz?: string;
  level?: 'error' | 'warn' | 'info' | 'debug';
}) {
  SLException?.reportAssertException(params);
}

// 其他异常
export function reportOtherException(params: {
  message: string;
  extra?: any;
  biz?: string;
  level?: 'error' | 'warn' | 'info' | 'debug';
}) {
  SLException?.reportOtherException(params);
}
